export default __webpack_public_path__ + "static/media/Workshop Left_.c0dff694.png";